module.exports = __webpack_public_path__ + "static/room5-f1aa4c625160bcf072641a9af9290e28.jpg";